(function($) {
  "use strict";

  jQuery(document).ready(function(){


    /*--
    Mobile Menu
------------------------*/
    var mainMenuNav = $('.main-menu nav');
    mainMenuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });

    /*--
    Category Menu
------------------------*/

    /*-- Variables --*/
    var categoryToggleWrap = $('.category-toggle-wrap');
    var categoryToggle = $('.category-toggle');
    var categoryMenu = $('.category-menu');

    /*
*  Category Menu Default Close for Mobile & Tablet Device
*  And Open for Desktop Device and Above
*/
    function categoryMenuToggle() {
      var screenSize = windows.width();
      if ( screenSize <= 991) {
        categoryMenu.slideUp();
      } else {
        categoryMenu.slideDown();
      }
    }

    /*-- Category Menu Toggles --*/
    function categorySubMenuToggle() {
      var screenSize = windows.width();
      if ( screenSize <= 991) {
        $('.category-menu .menu-item-has-children > a').prepend('<i class="expand menu-expand"></i>');
        $('.category-menu .menu-item-has-children ul').slideUp();
        //        $('.category-menu .menu-item-has-children i').on('click', function(e){
        //            e.preventDefault();
        //            $(this).toggleClass('expand');
        //            $(this).siblings('ul').css('transition', 'none').slideToggle();
        //        })
      } else {
        $('.category-menu .menu-item-has-children > a i').remove();
        $('.category-menu .menu-item-has-children ul').slideDown();
      }
    }
    categoryMenuToggle();
    windows.resize(categoryMenuToggle);
    categorySubMenuToggle();
    windows.resize(categorySubMenuToggle);

    categoryToggle.on('click', function(){
      categoryMenu.slideToggle();
    });

    /*-- Category Sub Menu --*/
    $('.category-menu').on('click', 'li a, li a .menu-expand', function(e) {
      var $a = $(this).hasClass('menu-expand') ? $(this).parent() : $(this);
      if ($a.parent().hasClass('menu-item-has-children')) {
        if ($a.attr('href') === '#' || $(this).hasClass('menu-expand')) {
          if ($a.siblings('ul:visible').length > 0) $a.siblings('ul').slideUp();
          else {
            $(this).parents('li').siblings('li').find('ul:visible').slideUp();
            $a.siblings('ul').slideDown();
          }
        }
      }
      if ($(this).hasClass('menu-expand') || $a.attr('href') === '#') {
        e.preventDefault();
        return false;
      }
    });

    /*-- Sidebar Category --*/
    var categoryChildren = $('.sidebar-category li .children');

    categoryChildren.slideUp();
    categoryChildren.parents('li').addClass('has-children');

    $('.sidebar-category').on('click', 'li.has-children > a', function(e) {

      if ($(this).parent().hasClass('has-children')) {
        if ($(this).siblings('ul:visible').length > 0) $(this).siblings('ul').slideUp();
        else {
          $(this).parents('li').siblings('li').find('ul:visible').slideUp();
          $(this).siblings('ul').slideDown();
        }
      }
      if ($(this).attr('href') === '#') {
        e.preventDefault();
        return false;
      }
    });

        /*--
	Add To Cart Animation
------------------------*/
    $('.add-to-cart').on('click', function(e){
      e.preventDefault(); 
        $(this).addClass('added').find('i').addClass('ti-check').removeClass('ti-shopping-cart').siblings('span').text('added'); 
    });
    
    /*--
    Header Search
------------------------*/
    var searchToggle = $('.search-toggle');
    var searchContainer = $('.header-search-container');

    searchToggle.on('click', function(){

      if( !$(this).hasClass('active') ) {
        $(this).addClass('active').find('i').removeClass('icofont-search-alt-1').addClass('icofont-close');
        searchContainer.slideDown();
      } else {
        $(this).removeClass('active').find('i').removeClass('icofont-close').addClass('icofont-search-alt-1');
        searchContainer.slideUp();
      }

    });
    /*--
    Header Cart
------------------------*/
    var headerCart = $('.header-cart');
    var closeCart = $('.close-cart, .cart-overlay');
    var miniCartWrap = $('.mini-cart-wrap');

    headerCart.on('click', function(e){
      e.preventDefault();
      $('.cart-overlay').addClass('visible');
      miniCartWrap.addClass('open');
    });
    closeCart.on('click', function(e){
      e.preventDefault();
      $('.cart-overlay').removeClass('visible');
      miniCartWrap.removeClass('open');
    });

    /*--
    Product Tab Filter Select Style For Mobile
--------------------------------------------*/
    function productTabFilterInit() {
      var productTabFilter = $('.product-tab-filter');

      productTabFilter.each(function(){
        var filterToggle = $(this).find('.product-tab-filter-toggle');
        var filterToggleCatElement = $(this).find('.product-tab-filter-toggle span');
        var filterList = $(this).find('.product-tab-list');
        var filterListItem = $(this).find('.product-tab-list li a');

        var filterCatText =  filterList.find('.active').text();

        filterToggleCatElement.text(filterCatText);

        /*-- Open Filter Tab List --*/
        filterToggle.on('click', function(){
          $(this).siblings('.product-tab-list').slideToggle();
        });

        /*-- Close Filter Tab List On Select a Category --*/
        filterListItem.on('click', function(){
          var screenSize = windows.width();
          var filterCatText= $(this).text();
          filterToggleCatElement.text(filterCatText);

          if ( screenSize < 767) {
            filterList.slideToggle();
          }

        });

      });

    }
    productTabFilterInit();

    /*-- Product Tab Filter Show Hide For Mobile & Desktop --*/
    function productTabFilterScreen() {
      var screenSize = windows.width();
      var filterList = $('.product-tab-list');

      if ( screenSize < 767) {
        filterList.slideUp();
      } else {
        filterList.slideDown();
      }
    }
    productTabFilterScreen();
    windows.resize(productTabFilterScreen);

    /*--
	Count Down Timer
------------------------*/
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<span class="cdown day"><span class="time-count">%-D</span> <p>Days</p></span> <span class="cdown hour"><span class="time-count">%-H</span> <p>Hours</p></span> <span class="cdown minutes"><span class="time-count">%M</span> <p>Minute</p></span> <span class="cdown second"><span class="time-count">%S</span> <p>Second</p></span>'));
      });
    });

    /*--
	CLose Popup
-----------------------------------*/
    $('.close-popup').on('click', function(){
      $('[data-modal="popup-modal"]').fadeOut('slow');
    });

    /*--
	Video Popup
-----------------------------------*/
    var videoPopup = $('.video-popup');
    videoPopup.magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });

    /*--
	Image Popup
-----------------------------------*/
    var imagePopup = $('.image-popup, .big-image-popup');
    imagePopup.magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
    });

    /*--
	Gallery Popup
-----------------------------------*/
    var galleryPopup = $('.gallery-popup');
    galleryPopup.magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      gallery: {
        enabled: true,
      },
    });

    /*--
	Counter UP
-----------------------------------*/
    var counter = $('.counter');
    counter.counterUp({
      delay: 20,
      time: 3000
    });

    /*--
	MailChimp
-----------------------------------*/
    $('#mc-form').ajaxChimp({
      language: 'en',
      callback: mailChimpResponse,
      // ADD YOUR MAILCHIMP URL BELOW HERE!
      url: 'http://devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

    });
    function mailChimpResponse(resp) {

      if (resp.result === 'success') {
        $('.mailchimp-success').html('' + resp.msg).fadeIn(900);
        $('.mailchimp-error').fadeOut(400);

      } else if(resp.result === 'error') {
        $('.mailchimp-error').html('' + resp.msg).fadeIn(900);
      }  
    }
    /*--
    Scroll Up
-----------------------------------*/
    $.scrollUp({
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade',
      scrollText: '<i class="icofont icofont-swoosh-up"></i>',
    });

    /*--
    Nice Select
------------------------*/
    $('.nice-select').niceSelect()

    /*----- 
	Quantity
--------------------------------*/
    $('.pro-qty').prepend('<span class="dec qtybtn">-</span>');
    $('.pro-qty').append('<span class="inc qtybtn">+</span>');
    $('.qtybtn').on('click', function() {
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.hasClass('inc')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find('input').val(newVal);
    });  

    /*----- 
	Shipping Form Toggle
--------------------------------*/ 
    $('[data-shipping]').on('click', function(){
      if( $('[data-shipping]:checked').length > 0 ) {
        $('#shipping-form').slideDown();
      } else {
        $('#shipping-form').slideUp();
      }
    })

    /*----- 
	Payment Method Select
--------------------------------*/
    $('[name="payment-method"]').on('click', function(){

      var $value = $(this).attr('value');

      $('.single-method p').slideUp();
      $('[data-method="'+$value+'"]').slideDown();

    })

    /*----- 
	Account Image Upload
--------------------------------*/
    $('#account-image-upload').on('change', function () {
      var filename = $(this).val();
      if (/^\s*$/.test(filename)) {
        $(".account-image-label").text("Choose your image"); 
      }
      else {
        $(".account-image-label").text(filename.replace("C:\\fakepath\\", ""));
      }
    });

    
        /* Ajax Cart */
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },1000);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },2000);

    });    

    /* Ajax Wishlist */
    $(".action--wishlist").on('click', function(){
      $(this).addClass("loading-wishlist add-wishlist");
      setTimeout(function () {
        $(".action--wishlist").removeClass("loading-wishlist");
      },1000);
      setTimeout(function () {
        $(".add-wishlist").removeClass("add-wishlist");
      },2000);

    });    
    

    /* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 


    /* Match Heigh */  
    $(function() {
      $('.item-2').matchHeight();
    });  

  });

})(jQuery);





/* Accordion not working
$(document).ready(function() {
var acc = document.getElementsByClassName("accordion2");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {

	if( !this.classList.contains('active2') ){
    	closeAll();
    }
	
  this.classList.toggle("active2");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
}

function openAll(){
    for (i = 0; i < acc.length; i++) {
    	acc[i].classList.add("active2");
        acc[i].nextElementSibling.style.maxHeight = acc[i].nextElementSibling.scrollHeight + "px";
    }
}

function closeAll(){
	 for (i = 0; i < acc.length; i++) {
    	acc[i].classList.remove("active2");
        acc[i].nextElementSibling.style.maxHeight = null;
    }
}

document.getElementById( 'openAll' ).addEventListener( 'click', openAll);
document.getElementById( 'closeAll' ).addEventListener( 'click', closeAll);
  
  });
  
  */



        /* Terms of Use Agreement Ticker */
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });